var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SecondaryLayout',{attrs:{"title":"掃描條碼"}},[_c('Scanner',{attrs:{"callback":msg=>_vm.scan(msg)}},[_c('div',[_vm._v("請掃描票券上的二維條碼")]),_c('div',{staticClass:"mt-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.input}},[_vm._v("手動輸入")])])]),_c('TicketModal',{ref:"add"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }